export default () => { 
    return {
        openTableAddParameter:false
    }
}